import styled from 'styled-components'
import { Link } from 'react-router-dom'
import logo from '../imgs/logomarca.png'

export default function Home() {
  return (
    <Main>
      <Container>
        <a
          href="https://www.usemaclah.com.br/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="Art Coco"></img>
        </a>
        <Botoes>
          <Link to={'/instrucao-calibragem'}>
            <button>MEDIR COM ANEL</button>
          </Link>

          <Link to={'/instrucao-sem-anel'}>
            <button>MEDIR COM BARBANTE</button>
          </Link>
          <a
            href="https://www.usemaclah.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <button>VISITAR A LOJA ON-LINE</button>
          </a>
        </Botoes>
      </Container>
      <Dev>
        <a href="https://linktr.ee/israel.felipe" target="blank">
          <h1>Desenvolvido por: Israel Felipe</h1>
        </a>
      </Dev>
    </Main>
  )
}

const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`

const Container = styled.div`
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10vh;
  /* background: rgba(255, 255, 255, 0.75);
  box-shadow: 0 8px 32px 0 rgba(149, 114, 39, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18); */

  @media (min-width: 500px) {
    height: 70vh;
  }

  @media (min-width: 1300px) {
    flex-direction: inherit;
    height: 70vh;
  }

  img {
    width: 75vw;
    max-width: 400px;
    max-height: 40vh;
    cursor: pointer;
    margin-top: -3vh;

    @media (min-width: 1300px) {
      max-width: 600px;
    }
  }
`

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3vh;

  @media (min-width: 1300px) {
    height: 100%;
    width: 100%;
  }

  button {
    width: 65vw;
    height: auto;
    padding: 18px;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 16px;
    cursor: pointer;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
    /* font-weight: bold; */
    background-image: linear-gradient(
      -45deg,
      #2196f3,
      #0d47a1,
      #0d47a1 50%,
      #2196f3
    );
    transition: background-position 0.3s;

    @media (min-width: 1300px) {
      margin: 0 5%;
      width: 90%;
      height: 20vh;
      font-size: 2vw;
    }

    &:hover {
      background-image: linear-gradient(
        90deg,
        #0d47a1,
        #2196f3,
        #2196f3 50%,
        #0d47a1
      );
      background-position: -100%;
    }
  }
`

const Dev = styled.h1`
  position: fixed;
  bottom: 0vh;
  width: 100%;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    color: #0d47a1;
    cursor: pointer;

    @media (min-width: 1300px) {
      font-size: 20px;
    }
  }
`
